import { createFile, updateFile } from '@/API/repositories/file';
import { FILE_TYPES } from '@/common/constants/fileTypes';
import { getBase64 } from '@/common/functions/getBase64';
import { useRequestsContext } from '@/common/hooks/requestHook';
import { useMessageQueueContext } from '@/common/hooks/useMessageQueue';
import { useFormik } from 'formik';

const useAttachmentForm = ({ setShow, selectedFile, reload }) => {
	const { makeRequest, hasUnfilledRequest } = useRequestsContext();
	const { addMessage } = useMessageQueueContext();

	const formik = useFormik({
		initialValues: {
			filename: selectedFile?.filename || '',
			base64: null,
			language: selectedFile?.language,
			workflow: selectedFile?.workflow,
		},
		onSubmit: (values) =>
			handleSubmit({
				...values,
				language: values.language?.value,
				workflow: values.workflow?.value,
				type: FILE_TYPES.ATTACHMENT,
			}),
	});

	const handleFileSelect = async (e) => {
		if (!e.target.files[0]) {
			formik.setFieldValue('org_filename', '');
			formik.setFieldValue('base64', '');
			return;
		}

		const file = e.target.files[0];
		const base64 = await getBase64(file);

		formik.setFieldValue('base64', base64);
		formik.setFieldValue('org_filename', file.name);
	};

	const handleSubmit = async (values) => {
		const requestFn = selectedFile ? updateFile : createFile;

		const response = await makeRequest(
			requestFn.bind(null, values, selectedFile?._id),
		);

		if (!response?.data) {
			return addMessage('Something went wrong', 'error');
		}

		addMessage('Success', 'success');
		setShow(false);
		reload();
	};

	const isLoading = hasUnfilledRequest(createFile, updateFile);

	return { isLoading, formik, handleFileSelect };
};

export default useAttachmentForm;
